import { Polygon, useMap } from 'react-leaflet';
import { useEffect, useMemo } from 'react';
import L from 'leaflet';

export default function SaarlandOverlay({ geoJson }) {
  const map = useMap();

  useEffect(() => {
    if (!geoJson) return;
    const bounds = L.geoJSON(geoJson).getBounds();
    // map.setMaxBounds(bounds);
    // animate:false avoids loading tiles for every intermediate zoom level
    // during the initial fit (which flooded the network/main thread on load).
    map.fitBounds(bounds, { animate: false });
  }, [geoJson, map]);

  const outerBounds = useMemo(() => [
    [-90, -180],
    [-90, 180],
    [90, 180],
    [90, -180],
    [-90, -180],
  ], []);

  const saarlandRings = useMemo(() => {
    const feature = geoJson.features[0];
    const geometry = feature.geometry;

    if (geometry.type === 'Polygon') {
      return [geometry.coordinates[0].map(([lng, lat]) => [lat, lng])];
    }

    if (geometry.type === 'MultiPolygon') {
      return geometry.coordinates.map(
        polygon => polygon[0].map(([lng, lat]) => [lat, lng])
      );
    }

    return [];
  }, [geoJson]);

  return (
    // Keep the default SVG renderer here: a canvas renderer re-rasterizes its
    // whole buffer on every zoom step, which stalls (or on 4K screens freezes)
    // the map, while SVG just scales this static polygon via GPU transform.
    <Polygon
      positions={[outerBounds, ...saarlandRings]}
      interactive={false}
      pathOptions={{
        fillColor: 'black',
        fillOpacity: 0.5,
        weight: 0,
      }}
    />
  );
}
